import { CodigosDeChamadaIntegracao } from './codigos-de-chamada-integracao.interface'
import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'
import { Bandeira } from '../../pkw-data/collect/bandeira.model'

export class ConfiguracaoIntegracaoBandeira {
    operadora: OperadoraDeMaquina
    bandeira: Bandeira
    codigos: CodigosDeChamadaIntegracao

    constructor(
        operadora?: OperadoraDeMaquina,
        bandeira?: Bandeira,
        codigos?: CodigosDeChamadaIntegracao
    ) {
        this.operadora = operadora
        this.bandeira = bandeira
        this.codigos = codigos

        if (!this.codigos) {
            this.codigos = {
                NomeDaOperadora: (operadora && operadora.nome) || '',
                Bandeira: (bandeira && bandeira.descricao) || '',
                VendaCredito: '',
                VendaDebito: '',
                RecebimentoLiquidoCredito: '',
                RecebimentoLiquidoDebito: '',
                TaxaOperadoraCredito: '',
                TaxaOperadoraDebito: '',
                EstornoDeVendasCredito: '',
                EstornoDeVendasDebito: '',
                Aluguel: '',
                OutrosAjustes: '',
                AntecipacaoTaxa: null
            }

            if (operadora && operadora.antecipa) {
                this.codigos.AntecipacaoTaxa = ''
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/configuracao/shared/configuracao-integracao-bandeira.ts